import React from 'react';
import { Box, Typography } from '@mui/material';

// Thread header: shows the selected conversation's name / subject.
// Colors come from theme semantic keys (no hardcoded hex).
const Header = ({ conversation }) => (
  <Box
    sx={{
      p: 2,
      bgcolor: 'background.secondary',
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Typography variant="h5" fontWeight="bold">
      {conversation?.name || 'Conversation'}
    </Typography>
    {conversation?.subject && (
      <Typography variant="body2" color="text.secondary">
        {conversation.subject}
      </Typography>
    )}
  </Box>
);

export default Header;
